var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundThemeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_187258",
    "data-name": "Group 187258",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.075,
    height: 23.075,
    viewBox: "0 0 23.075 23.075",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3299",
    "data-name": "Rectangle 3299",
    width: 23.075,
    height: 23.075,
    fill: "#7119bf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187257",
    "data-name": "Group 187257",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90437",
    "data-name": "Path 90437",
    d: "M16.778,24.329H1.979c-.158-.083-.319-.241-.472-.233a.752.752,0,0,1-.542-.259,1.918,1.918,0,0,1-.879-1.446c0-.045-.056-.087-.086-.131V7.055l.071-.034L0,6.965V6.92a.792.792,0,0,0,.089-.133,2.47,2.47,0,0,1,1.259-1.4,1.158,1.158,0,0,0,.225-.179l.054.062.038-.062c.331-.026.663-.073.994-.074q6.7-.007,13.393,0a7.188,7.188,0,0,1,.981.041,2.783,2.783,0,0,1,.737.224,6.057,6.057,0,0,1,.655.391c.07-.172.141-.35.214-.526.182-.439.363-.879.55-1.316.166-.39.339-.778.508-1.166l.115-.027-.06-.061a4.536,4.536,0,0,1,.285-.665,1.556,1.556,0,0,1,1.4-.7,1.66,1.66,0,0,1,1.512,1.18c.03.144.072.269-.05.385.177.176.052.371.034.56l-.125.273c-.112.019-.19.055-.089.18l-.187.444L22.5,4.4l-.174.371-.6,1.289-.035.049-.37.805-.035.049-.138.272c-.135.009-.151.077-.093.183l-.312.671-.044.09-.36.765-.089.18-.187.444-.035.049-.174.371-.6,1.289-.035.049c-.007.133-.019.265-.019.4q-.018,5.089-.034,10.177a2.294,2.294,0,0,1-.416,1.331,2.4,2.4,0,0,1-.949.853,5.688,5.688,0,0,1-.7.242h-.315Zm-4.229-7.412a.675.675,0,0,0,.219-.08A1.735,1.735,0,0,1,13.79,16.5a.277.277,0,0,0,.192-.119c.1-.192.176-.4.259-.6.141-.342.28-.685.422-1.032H11.5v3.3l.814-.96.052-.036.128-.1.052-.036m1.3.567c-.109.014-.219.02-.326.042-.566.119-.852.6-1.179.99a1.78,1.78,0,0,0-.244.776,3.136,3.136,0,0,1-1.161,1.7,3.24,3.24,0,0,0,2.319.244c.1.111.126.1.183-.058a.89.89,0,0,0,.246-.051c.443-.236.937-.41,1.166-.919.1-.215.207-.423.3-.64a2.073,2.073,0,0,0,.065-1.175,1.343,1.343,0,0,0-1.278-.907l-.045-.064-.045.065M19.34,8.849l.37-.805.035-.05.36-.711V7.232a.107.107,0,0,1,.01-.042l.035-.049.62-1.314c.408-.862.819-1.723,1.221-2.589a.693.693,0,0,0,.052-.345.713.713,0,0,0-.47-.6c-.363-.04-.653,0-.807.385-.17.423-.375.831-.552,1.252-.254.606-.5,1.216-.744,1.825l-.038.04c-.014,0-.039,0-.042.012-.092.272-.181.545-.273.817-.058.171-.109.344-.181.508-.106.239-.24.466-.343.706-.2.474-.394.953-.585,1.432-.045.113-.061.239-.108.351-.129.3-.27.6-.4.906-.061.144-.1.3-.16.441-.13.289-.281.569-.4.861s-.229.606-.35.933c.191.1.384.179.563.284.13.076.182.029.233-.087.082-.185.173-.366.26-.548l.035-.049.339-.728.038.015-.031-.023.474-1.014.035-.05L19.3,8.9l.035-.05m-3,8.551c-.07.15-.15.3-.206.451a.321.321,0,0,0,.005.229,1.7,1.7,0,0,1,.089.82,2.994,2.994,0,0,1-.3,1.273,3.158,3.158,0,0,1-1.042,1.378,3.711,3.711,0,0,1-.717.344,7.318,7.318,0,0,1-.983.31c-.216.048-.463.146-.664-.071a.106.106,0,0,0-.094.012c-.072.189-.243.117-.374.149l-.091-.034-.379-.107h.005c-.014.012-.031.037-.042.034a3.536,3.536,0,0,1-.838-.213c-.427-.224-.927-.378-1.069-.961a.313.313,0,0,1,.058-.335,1.639,1.639,0,0,1,.146-.133l.186-.124a.57.57,0,0,0,.095-.052c.185-.153.436-.244.435-.554q-.007-2.686,0-5.373c0-.09,0-.18.009-.269a.416.416,0,0,1,.355-.371c.215-.018.43-.034.645-.035,1.094,0,2.188,0,3.282,0h.232l.391-.955H3.406a.469.469,0,0,1-.526-.513c0-1.266,0-2.533,0-3.8a.376.376,0,0,1,.181-.371c.056.03.139.1.164.083a.768.768,0,0,0,.154-.19c.052,0,.1-.012.156-.012H15.688c.439.013.627.205.629.646,0,.4,0,.794,0,1.191v.879c.238-.482.437-.969.642-1.453.269-.632.565-1.253.806-1.895.1-.263.388-.556.046-.858l-.14-.095a1.623,1.623,0,0,0-.42-.217,5.452,5.452,0,0,0-.982-.105q-6.439-.01-12.878,0c-.415,0-.83.036-1.245.054a1.244,1.244,0,0,0-1.021.681,1.753,1.753,0,0,0-.172,1c.009,1.731.005,3.461,0,5.192,0,2.989-.012,5.978,0,8.967a2.322,2.322,0,0,0,.216.667l.078.093c.078.144.252.205.335.3a.985.985,0,0,0,.84.313c2.007,0,4.014,0,6.022,0,2.778,0,5.557.011,8.335.005a1.611,1.611,0,0,0,.607-.145,1.358,1.358,0,0,0,.7-.749l.034-.048a3.79,3.79,0,0,0,.1-.608q.01-4.046,0-8.092c0-.059-.009-.117-.014-.176l-.058-.007c-.091.2-.179.406-.275.606-.381.8-.766,1.589-1.146,2.385-.127.266-.243.538-.364.807l-.035.049M3.847,11.844H15.335V8.986H3.847Zm12.326,1.8L14.89,16.7l.546.379L16.9,14l-.726-.357m.143-2.834L16.3,10.8v.015Z",
    transform: "translate(0 -1.254)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90441",
    "data-name": "Path 90441",
    d: "M0,101.378l.071.055L0,101.468v-.09",
    transform: "translate(0 -95.667)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90442",
    "data-name": "Path 90442",
    d: "M0,108.564v0Z",
    transform: "translate(0 -102.448)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90443",
    "data-name": "Path 90443",
    d: "M40.721,409.6h0Z",
    transform: "translate(-38.427 -386.525)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90444",
    "data-name": "Path 90444",
    d: "M0,103.773v0Z",
    transform: "translate(0 -97.927)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90445",
    "data-name": "Path 90445",
    d: "M297.818,409.6h0Z",
    transform: "translate(-281.04 -386.525)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90451",
    "data-name": "Path 90451",
    d: "M54.262,120.249l.317-.107a.77.77,0,0,1-.154.19c-.025.017-.107-.053-.164-.083",
    transform: "translate(-51.205 -113.374)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90452",
    "data-name": "Path 90452",
    d: "M174.659,340.285c-.036-.188.1-.116.186-.124l-.186.124",
    transform: "translate(-164.813 -320.991)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90453",
    "data-name": "Path 90453",
    d: "M235.446,353.672l.183-.058c-.057.161-.081.169-.183.058",
    transform: "translate(-222.182 -333.693)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90454",
    "data-name": "Path 90454",
    d: "M402.61,43.915l-.089.18c-.1-.125-.023-.161.089-.18",
    transform: "translate(-379.8 -41.441)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90455",
    "data-name": "Path 90455",
    d: "M373.264,106.2l-.093.183c-.058-.106-.042-.175.093-.183",
    transform: "translate(-352.118 -100.216)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90456",
    "data-name": "Path 90456",
    d: "M359.48,136.542l-.089.18.089-.18",
    transform: "translate(-339.144 -128.85)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90457",
    "data-name": "Path 90457",
    d: "M313.806,91.89l-.14-.095.14.095",
    transform: "translate(-295.995 -86.624)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90458",
    "data-name": "Path 90458",
    d: "M27.929,70.187h.092l-.038.062-.054-.062",
    transform: "translate(-26.356 -66.233)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90459",
    "data-name": "Path 90459",
    d: "M349.648,25.608l.055-.089.06.061-.115.027",
    transform: "translate(-329.95 -24.081)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90460",
    "data-name": "Path 90460",
    d: "M212.459,372.956l-.091-.034.091.034",
    transform: "translate(-200.404 -351.913)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90461",
    "data-name": "Path 90461",
    d: "M20.777,380.008l.078.093-.078-.093",
    transform: "translate(-19.607 -358.6)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90462",
    "data-name": "Path 90462",
    d: "M367.419,121.37l-.044.09.044-.09",
    transform: "translate(-346.679 -114.533)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90463",
    "data-name": "Path 90463",
    d: "M246.008,287h-.09l.045-.065.045.064",
    transform: "translate(-232.064 -270.772)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90464",
    "data-name": "Path 90464",
    d: "M328.3,165.217l.035-.05Z",
    transform: "translate(-309.805 -155.862)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90465",
    "data-name": "Path 90465",
    d: "M313.137,197.164l.035-.049-.035.049",
    transform: "translate(-295.496 -186.01)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90466",
    "data-name": "Path 90466",
    d: "M319.778,184.056l.031.023-.038-.015.007-.008",
    transform: "translate(-301.756 -173.687)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90467",
    "data-name": "Path 90467",
    d: "M341.117,177.95l-.035.049.035-.049",
    transform: "translate(-321.867 -167.925)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90468",
    "data-name": "Path 90468",
    d: "M289.41,169.428l-.013.007v-.015Z",
    transform: "translate(-273.093 -159.875)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90469",
    "data-name": "Path 90469",
    d: "M355.493,147.613l-.035.049.035-.049",
    transform: "translate(-335.433 -139.297)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90470",
    "data-name": "Path 90470",
    d: "M221.823,278.059l.052-.036-.052.036",
    transform: "translate(-209.326 -262.36)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90471",
    "data-name": "Path 90471",
    d: "M218.64,280.449l.052-.036-.052.036",
    transform: "translate(-206.323 -264.616)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90472",
    "data-name": "Path 90472",
    d: "M290.012,285.74l-.035.049.035-.049",
    transform: "translate(-273.641 -269.643)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90473",
    "data-name": "Path 90473",
    d: "M342.674,134.874l.035-.05-.035.05",
    transform: "translate(-323.369 -127.229)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90474",
    "data-name": "Path 90474",
    d: "M349.861,119.7l.035-.05-.035.05",
    transform: "translate(-330.151 -112.912)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90475",
    "data-name": "Path 90475",
    d: "M356.317,106.16l-.034-.033.034-.018v.052",
    transform: "translate(-336.211 -100.13)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90476",
    "data-name": "Path 90476",
    d: "M357.05,104.536l.035-.049-.035.049",
    transform: "translate(-336.935 -98.601)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90477",
    "data-name": "Path 90477",
    d: "M377.841,100.487l-.035.049.035-.049",
    transform: "translate(-356.522 -94.826)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90478",
    "data-name": "Path 90478",
    d: "M321.14,376.041l.034-.048-.034.048",
    transform: "translate(-303.048 -354.811)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90479",
    "data-name": "Path 90479",
    d: "M385.031,85.323l-.035.049Z",
    transform: "translate(-363.307 -80.516)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90480",
    "data-name": "Path 90480",
    d: "M344.969,79.824l-.038.04Z",
    transform: "translate(-325.499 -75.327)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90481",
    "data-name": "Path 90481",
    d: "M399.407,54.986l-.035.049.035-.049",
    transform: "translate(-376.873 -51.888)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90482",
    "data-name": "Path 90482",
    d: "M51.1,225.931q0-1.63,0-3.26c0-.374.169-.542.552-.554.082,0,.165,0,.247,0h4.271c.492,0,.686.191.686.675,0,2.1,0,4.2-.007,6.3a.976.976,0,0,1-.159.525.544.544,0,0,1-.394.178c-1.566.012-3.132.008-4.7.007a.465.465,0,0,1-.5-.494q0-1.686,0-3.372m4.789-2.832H52.07v5.732h3.817Z",
    transform: "translate(-48.218 -209.603)",
    fill: "#7119bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90483",
    "data-name": "Path 90483",
    d: "M205.091,371.022l-.014.049-.019-.009.037-.039h0",
    transform: "translate(-193.507 -350.12)",
    fill: "#7119bf"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundThemeIcon);
export default __webpack_public_path__ + "static/media/background-theme-icon.b29866a685491291e59e4da0a3f21ae4.svg";
export { ForwardRef as ReactComponent };